// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-bg {
  background-color: rgb(0, 0, 0);
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0)
    ),
    linear-gradient(rgb(51, 51, 51), rgb(51, 51, 51));
  padding: 10px 0px;
  color: white;
  bottom: 0px;
  position: fixed;
}

.msg {
  font-family: Saira;
  font-size: 2rem;
  font-weight: lighter;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.35;
  letter-spacing: normal;
  text-align: left;
}

/* .msg::after,
.msg::before {
  content: "\\0022 ";
  font-family: "Saira";
  font-size: 100px;
  font-weight: 300;
  line-height: 10px;
  text-align: left;
  color: rgb(227, 24, 55);
  vertical-align: -webkit-baseline-middle;
} */

.quote-start {
  font-size: 100px;
  font-weight: 300;
  line-height: 10px;
  text-align: left;
  color: rgb(227, 24, 55);
  vertical-align: -webkit-baseline-middle;
}

.quoteWidth {
  width: 7%;
  margin-top: 12px;
}

.quote-end {
  font-size: 100px;
  font-weight: 300;
  line-height: 1;
  text-align: right;
  color: rgb(227, 24, 55);
  vertical-align: -webkit-baseline-middle;
}

.links {
  font-family: Saira;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
  color: #fefbfb;
  margin-top: 0.75rem;
}

.links a:hover {
  color: #db233a;
}

@media screen and (max-width: 768px) {
  .msg {
    font-family: Saira;
    font-size: 1.5rem;
    font-weight: lighter;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.75;
    letter-spacing: normal;
    text-align: left;
    margin-left: 0.25rem;
  }

  .quoteWidth {
    width: 11%;
    margin-top: 12px;
  }

  .quote-start {
    text-align: left;
    vertical-align: bottom;
  }

  .quote-end {
    line-height: 0.2;
    vertical-align: bottom;
  }

  .links {
    font-family: Saira;
    font-size: 9px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #fefbfb;
  }
}
`, "",{"version":3,"sources":["webpack://./src/template/app/FooterNew.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B;;;;;qDAKmD;EACnD,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;EAChB;AACF","sourcesContent":[".footer-bg {\n  background-color: rgb(0, 0, 0);\n  background-image: linear-gradient(\n      to right,\n      rgba(0, 0, 0, 0.8),\n      rgba(0, 0, 0, 0)\n    ),\n    linear-gradient(rgb(51, 51, 51), rgb(51, 51, 51));\n  padding: 10px 0px;\n  color: white;\n  bottom: 0px;\n  position: fixed;\n}\n\n.msg {\n  font-family: Saira;\n  font-size: 2rem;\n  font-weight: lighter;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.35;\n  letter-spacing: normal;\n  text-align: left;\n}\n\n/* .msg::after,\n.msg::before {\n  content: \"\\0022 \";\n  font-family: \"Saira\";\n  font-size: 100px;\n  font-weight: 300;\n  line-height: 10px;\n  text-align: left;\n  color: rgb(227, 24, 55);\n  vertical-align: -webkit-baseline-middle;\n} */\n\n.quote-start {\n  font-size: 100px;\n  font-weight: 300;\n  line-height: 10px;\n  text-align: left;\n  color: rgb(227, 24, 55);\n  vertical-align: -webkit-baseline-middle;\n}\n\n.quoteWidth {\n  width: 7%;\n  margin-top: 12px;\n}\n\n.quote-end {\n  font-size: 100px;\n  font-weight: 300;\n  line-height: 1;\n  text-align: right;\n  color: rgb(227, 24, 55);\n  vertical-align: -webkit-baseline-middle;\n}\n\n.links {\n  font-family: Saira;\n  font-size: 12px;\n  font-weight: normal;\n  font-style: normal;\n  line-height: 1.33;\n  letter-spacing: normal;\n  text-align: right;\n  color: #fefbfb;\n  margin-top: 0.75rem;\n}\n\n.links a:hover {\n  color: #db233a;\n}\n\n@media screen and (max-width: 768px) {\n  .msg {\n    font-family: Saira;\n    font-size: 1.5rem;\n    font-weight: lighter;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.75;\n    letter-spacing: normal;\n    text-align: left;\n    margin-left: 0.25rem;\n  }\n\n  .quoteWidth {\n    width: 11%;\n    margin-top: 12px;\n  }\n\n  .quote-start {\n    text-align: left;\n    vertical-align: bottom;\n  }\n\n  .quote-end {\n    line-height: 0.2;\n    vertical-align: bottom;\n  }\n\n  .links {\n    font-family: Saira;\n    font-size: 9px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.33;\n    letter-spacing: normal;\n    text-align: center;\n    color: #fefbfb;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
